import { DateTime } from 'luxon';

/*
 * Network tab data helpers. The router header/stats now come from the real getRouters
 * data; ports and recent activity stay MOCK until those payloads exist.
 */

export interface RouterPort {
  id: string;
  label: string;
  state: string;
  speed: string;
  poe: boolean;
  role: string;
}

/*
 * Assumed shape (the real `activity` payload isn't documented yet). `good` toggles the
 * green dot; `at` drives the relative "X min ago" label.
 */
export interface RouterActivity {
  at?: string | null;
  message: string;
  good?: boolean;
}

// The shape the Network tab renders (built from a real router + mock ports/activity).
export interface CloutikRouter {
  model?: string;
  online?: boolean;
  lastConAt?: string | null;
  uptimeSec?: number;
  wanIp?: string;
  serial?: string;
  cloutikUrl?: string;
  ports?: RouterPort[];
  activity?: RouterActivity[];
}

export const MOCK_PORTS: RouterPort[] = [
  { id: 'ether1', label: 'ether1', state: 'up', speed: '1Gbps', poe: false, role: 'empty' },
  { id: 'ether2', label: 'ether2', state: 'up', speed: '1Gbps', poe: false, role: 'empty' },
  { id: 'ether3', label: 'ether3', state: 'up', speed: '1Gbps', poe: false, role: 'empty' },
  { id: 'ether4', label: 'ether4', state: 'down', speed: '1Gbps', poe: false, role: 'empty' },
  { id: 'ether5', label: 'ether5', state: 'down', speed: '1Gbps', poe: false, role: 'empty' }
];

export const mockActivity = (): RouterActivity[] => [
  {
    at: DateTime.now().minus({ minutes: 1 }).toISO(),
    message: 'Configuration synced from Cloutik'
  },
  {
    at: DateTime.now().minus({ minutes: 22 }).toISO(),
    message: 'Speedtest completed · 92.0 ↓ / 20.4 ↑ Mbps · 17 ms',
    good: true
  },
  {
    at: DateTime.now().minus({ days: 4 }).toISO(),
    message: 'Router last rebooted · back online in 48s'
  }
];
